const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  905: {
    path: "/financeManage",
    name: "financeManage",
    meta: {
      title: "财务管理",
      authId: "905",
      parentId: "1",
      cache: false
    }
  },
  90501: {
    path: "/financeList",
    name: "financeList",
    meta: {
      title: "财务列表",
      authId: "90501",
      parentId: "905",
      cache: false
    },
    auth: [
      {
        authId: "9050103",
        parentId: "90501",
        label: "下载对账单",
        icon: "download",
        category: "Button",
        type: "primary",
        handle: "downloadAccount"
      },
      {
        authId: "9050101",
        parentId: "90501",
        label: "合并导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9050102",
        parentId: "90501",
        label: "查看明细",
        handle: "handleDetail",
        addRoutePath: [
          {
            authId: "90502",
            name: "对账详情",
            parentId: "90501"
          }
        ]
      }
    ],
    component: _import("financeManage/index")
  },
  90502: {
    path: "/financeDetail",
    name: "financeDetail",
    meta: {
      title: "对账详情",
      authId: "90502",
      parentId: "90501",
      cache: false,
      activePath: "/financeList"
    },
    component: _import("financeManage/financeDetailNew")
  },
  90503: {
    path: "/onlineAccountList",
    name: "onlineAccountList",
    meta: {
      title: "我的分账",
      authId: "90503",
      parentId: "905",
      cache: false
    },
    auth: [
      //   {
      //   authId: '9050301',
      //   parentId: '90503',
      //   label: '提现记录',
      //   category: 'Button',
      //   type: 'primary',
      //   handle: 'handleRecord'
      // },
      {
        authId: "9050302",
        parentId: "90503",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      }
    ],
    component: _import("financeManage/account/index")
  },
  90504: {
    path: "/accountRecord",
    name: "accountRecord",
    meta: {
      title: "提现记录",
      authId: "90504",
      parentId: "90503",
      cache: false,
      activePath: "/onlineAccountList"
    },
    component: _import("financeManage/account/accountRecord")
  },
  90505: {
    path: "/transferAccountsManage",
    name: "transferAccountsManage",
    meta: {
      title: "转账管理",
      authId: "90505",
      parentId: "905",
      cache: false
    },
    auth: [
      {
        authId: "9050501",
        parentId: "90505",
        label: "新增转账",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "handleAdd"
      },
      {
        authId: "9050512",
        parentId: "90505",
        label: "批量商务审核",
        category: "Button",
        type: "primary",
        handle: "handleLeaderAllExamine"
      },
      {
        authId: "9050502",
        parentId: "90505",
        label: "批量运营审核",
        category: "Button",
        type: "primary",
        handle: "handleBatchExamine"
      },

      {
        authId: "9050503",
        parentId: "90505",
        label: "批量财务确认",
        category: "Button",
        type: "primary",
        handle: "handleBatchConfirm"
      },
      {
        authId: "9050504",
        parentId: "90505",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9050505",
        parentId: "90505",
        label: "查看",
        handle: "handleDetail"
      },
      {
        authId: "9050506",
        parentId: "90505",
        label: "审核",
        handle: "handleExamine"
      },
      {
        authId: "9050507",
        parentId: "90505",
        label: "确认",
        handle: "handleConfirm"
      },
      {
        authId: "9050508",
        parentId: "90505",
        label: "驳回",
        handle: "handleReject"
      },
      {
        authId: "9050509",
        parentId: "90505",
        label: "重新发起转账",
        handle: "handleReTransfer"
      },
      {
        authId: "9050510",
        parentId: "90505",
        label: "重新发起提现",
        handle: "handleReWithdrawal"
      },
      {
        authId: "9050511",
        parentId: "90505",
        label: "审核",
        handle: "handleLeaderExamine"
      }
    ],
    component: _import("financeManage/transferAccountsManage/index")
  },
  90506: {
    path: "/withdrawalManage",
    name: "withdrawalManage",
    meta: {
      title: "提现管理",
      authId: "90506",
      parentId: "905",
      cache: false
    },
    auth: [
      {
        authId: "9050601",
        parentId: "90506",
        label: "新增提现",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "handleAdd"
      },
      {
        authId: "9050602",
        parentId: "90506",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9050603",
        parentId: "90506",
        label: "重新发起提现",
        handle: "handleReWithdrawal"
      }
    ],
    component: _import("financeManage/withdrawalManage/index")
  },
  90507: {
    path: "/limitMonitor",
    name: "limitMonitor",
    meta: {
      title: "额度监控",
      authId: "90507",
      parentId: "905",
      cache: false
    },
    auth: [
      {
        authId: "9050701",
        parentId: "90507",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9050702",
        parentId: "90507",
        label: "编辑",
        handle: "handleEdit"
      }
    ],
    component: _import("financeManage/limitMonitor/index")
  },
  90508: {
    path: "/balanceStatistics",
    name: "balanceStatistics",
    meta: {
      title: "余额统计",
      authId: "90508",
      parentId: "905",
      cache: false
    },
    auth: [
      {
        authId: "9050801",
        parentId: "90508",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9050802",
        parentId: "90508",
        label: "明细",
        handle: "handleDetail"
      }
    ],
    component: _import("financeManage/balanceStatistics/index")
  },
  90509: {
    path: "/theAssetData",
    name: "theAssetData",
    meta: {
      title: "财资数据",
      authId: "90509",
      parentId: "905",
      cache: false
    },
    auth: [
      {
        authId: "9050901",
        parentId: "90509",
        label: "重取明细",
        category: "Button",
        type: "primary",
        handle: "handleRefetchDetail"
      },
      {
        authId: "9050902",
        parentId: "90509",
        label: "批量重推",
        category: "Button",
        type: "primary",
        handle: "handleBatchRepush"
      },
      {
        authId: "9050903",
        parentId: "90509",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9050904",
        parentId: "90509",
        label: "详情",
        handle: "handleDetail"
      },
      {
        authId: "9050905",
        parentId: "90509",
        label: "回单",
        handle: "handleReceipt"
      }
    ],
    component: _import("financeManage/theAssetData/index")
  }
}
